import type { Catalog } from "../../en";
import { availability } from "./availability";
import { bookingForm } from "./booking-form";

export const actions: Catalog["build"]["actions"] = {
  title: "Mga aksyon",
  subtitle: "Hinahayaan ng mga aksyon na may gawin ang assistant, hindi lang sumagot — mag-book ng appointment, mag-save ng lead, tumingin ng status sa iyong mga system.",
  tryPlayground: "Subukan sa Playground",
  newAction: "Bagong aksyon",
  kpi: {
    active: "Aktibong aksyon",
    runs: "Mga run (7 araw)",
    runsDelta: "{{value}} kumpara noong nakaraang linggo",
    successRate: "Success rate",
    failed_one: "{{count}} ang pumalya",
    failed_other: "{{count}} ang pumalya",
    mostly: "{{count}} ang pumalya · kadalasan {{reason}}",
    median: "Median na tagal",
    p95: "p95 {{value}}",
    none: "Wala pang run",
  },
  filter: {
    label: "I-filter ang mga aksyon",
    all: "Lahat · {{count}}",
    builtin: "Built-in · {{count}}",
    custom: "Custom at integrations · {{count}}",
    search: "Maghanap ng aksyon",
  },
  card: {
    toggle: "I-enable ang {{name}}",
    toggleLocked: "Laging naka-on ang {{name}}",
    alwaysOn: "Laging naka-on",
    runs: "{{count}} run · 7a",
    off: "Naka-off",
    requiresIdentity: "Kailangan ng verified na identity",
    builtinLeads: "Built-in → Leads",
    builtinInbox: "Built-in → Inbox",
    builtinEmail: "Built-in na email",
    builtinBooking: "Built-in na booking",
    builtin: "Built-in",
    integration: {
      custom_api: "Custom API",
      webhook: "Webhook",
      zapier: "Zapier",
    },
    enabled: "Na-enable ang {{name}}",
    disabled: "Na-disable ang {{name}}",
    routing: {
      label: "Napupunta ang mga handoff sa",
      team: "{{name}} team",
      person: "{{name}}",
      fallback: "Owner at mga Admin",
      payment: "Mga paksa ng bayad: {{name}}",
      change: "Napupunta ang mga handoff sa {{target}}. Baguhin sa Escalation at handoff settings",
    },
    booking: {
      calendar: "Google Calendar",
      request: "Kumpirmasyon ng staff",
      unconfigured: "Itakda ang oras ng bukas",
    },
  },
  empty: {
    title: "Wala pang aksyon",
    body: "Ikonekta ang assistant sa iyong mga system: tumingin ng status, gumawa ng ticket o magpadala ng data sa webhook.",
    noMatch: "Walang aksyong tugma sa filter",
    noMatchBody: "Subukan ang ibang paghahanap o ipakita ang lahat.",
  },
  templates: {
    title: "Bagong aksyon",
    subtitle: "Magsimula sa template. Mababago mo ang lahat mamaya.",
    custom_api: "Custom API",
    custom_apiBody: "Tawagan ang sarili mong system o kahit anong REST endpoint",
    webhook: "Webhook",
    webhookBody: "Mag-POST ng data ng usapan sa iyong server",
    zapier: "Zapier",
    zapierBody: "Mag-trigger ng Zap gamit ang catch hook URL",
    booking: "Booking",
    bookingBody: "Hayaang mag-book ang mga bisita ng tour, demo o appointment sa chat",
    bookingName: "Mag-book ng appointment",
    bookingCreated: "Nagawa ang booking action. Itakda ang oras at form sa ibaba.",
  },
  editor: {
    editTitle: "I-edit ang aksyon",
    newTitle: "Bago: {{template}}",
    kicker: "Aksyon",
    name: "Pangalan",
    toolName: "Tool name (para sa AI)",
    toolNameHint: "Maliliit na titik, numero at underscore.",
    toolNameInvalid: "Gumamit ng maliliit na titik, numero at underscore (2–63 character, nagsisimula sa titik).",
    nameRequired: "Maglagay ng pangalan.",
    whenToUse: "Kailan gagamitin",
    whenToUseHint: "Binabasa ito ng AI para malaman kung kailan tatawagin ang aksyon.",
    whenToUseCount: "{{used}} / {{max}} na character",
    whenToUseHelp: {
      summary: "Paano sumulat ng mahusay na paglalarawan",
      intro: "Ito ang pangunahing binabasa ng AI kapag pumipili ng aksyon. Saklawin ang apat na puntong ito:",
      p1: "Ano ang ginagawa ng aksyon at ano ang ibinabalik nito.",
      p2: "Kailan ito gagamitin, sa mga salitang gagamitin ng bisita.",
      p3: "Kailan HINDI ito gagamitin, at anong ibang aksyon ang gagamitin sa halip.",
      p4: "Ang mga detalyeng dapat ibigay ng bisita (halimbawa, item code). Kung kulang, hindi dapat tawagin ng AI.",
      exampleTitle: "Halimbawa: ilista ang mga item sa isang tindahan",
      example: "Inililista ang mga item sa aming tindahan kasama ang pangalan at presyo. Gamitin kapag nagtanong ang bisita kung ano ang aming binebenta, ano ang available, o gustong makita ang catalogue. HUWAG gamitin para hanapin ang isang item gamit ang code (gamitin ang Get item) o para mag-order (gamitin ang Create order).",
    },
    whenRequired: "Ilarawan kung kailan dapat gamitin ng assistant ang aksyong ito.",
    whenTooLong: "Panatilihin sa loob ng {{max}} character.",
    builtinNote: "Built-in na aksyon: puwede mo itong palitan ng pangalan, baguhin ang gabay at mga switch, o i-off. Ang platform ang namamahala sa mga parameter nito.",
    parameters: "Mga parameter",
    addParameter: "Magdagdag ng parameter",
    paramName: "Pangalan",
    paramType: "Uri",
    paramRequired: "Kailangan",
    paramDescription: "Paglalarawan",
    paramRemove: "Alisin ang parameter na {{name}}",
    paramsNone: "Walang parameter: walang detalyeng ipinapadala ang assistant, tama ito para sa simpleng listahan. Magdagdag kung kailangan ng endpoint ng input, tulad ng item code.",
    paramPlaceholder: "param_name",
    paramDescriptionPlaceholder: "Ano ang dapat ilagay ng AI dito",
    paramInvalid: "Dapat natatangi ang pangalan ng parameter at nagsisimula sa titik o underscore.",
    editJson: "I-edit bilang JSON",
    editTable: "I-edit bilang table",
    jsonLabel: "JSON Schema ng parameter",
    jsonInvalid: "Hindi ito wastong JSON Schema object na gumagamit ng mga suportadong keyword.",
    types: { string: "string", number: "number", integer: "integer", boolean: "boolean", date: "date" },
    http: "HTTP request",
    method: "Method",
    url: "URL",
    urlHint: "Gumamit ng {{example}} na placeholder sa path o query. Hindi puwedeng i-template ang host.",
    urlInvalid: "Maglagay ng https:// URL. Dapat tugma sa parameter ang mga placeholder at wala sa host.",
    headers: "Mga header",
    addHeader: "Magdagdag ng header",
    headerName: "Pangalan ng header",
    headerValue: "Value ng header",
    headerRemove: "Alisin ang header na {{name}}",
    auth: "Authentication",
    authTypes: { none: "Wala", api_key: "API key (header)", bearer: "Bearer token", hmac: "HMAC signature" },
    authHeader: "Pangalan ng header",
    secret: "Secret",
    secretHint: "Naka-encrypt kapag naka-imbak. Hindi kailanman ipinapakita sa model.",
    secretSaved: "Naka-save — iwanang blangko para panatilihin",
    secretRequired: "Ilagay ang credential para sa uri ng authentication na ito.",
    timeout: "Timeout (ms)",
    timeoutHint: "Sa pagitan ng 1,000 at 30,000 ms. Kapag nag-timeout, maayos na magpa-fallback ang assistant.",
    mapping: "Response mapping",
    mappingHint: "Ang mga naka-map na field lang ang ibinabalik sa assistant. Kung walang mapping, matatanggap nito ang buong response; ang mahabang listahan ay puputulin sa mga item na kasya at lalagyan ng tanda na bahagi lamang.",
    mappingListHint: "Gamitin ang [*] para sa bawat item ng listahan: ang {{example}} ay nagbibigay ng listahan ng mga pangalan (hanggang {{max}}). Pinapantay ng pangalawang [*] ang mga nested na listahan.",
    mappingFieldPlaceholder: "names",
    mappingPathPlaceholder: "$.items[*].name",
    mappingField: "Field",
    mappingPath: "JSON path",
    addMapping: "Magdagdag ng mapping",
    mappingRemove: "Alisin ang mapping na {{name}}",
    mappingInvalid: "Kailangan ng pangalan at path ang field, hal. $.data.status o $.items[*].name. Nakalaan ang pangalang _truncated.",
    confirm: "Humingi ng kumpirmasyon bago patakbuhin",
    confirmHint: "Magtatanong muna ang assistant sa user bago patakbuhin ang aksyon.",
    confirmHintRead: "Naka-off bilang default para sa GET: ang read-only na paghahanap (tulad ng paglista ng mga item) ay tumatakbo agad. I-on para magpakita muna ng confirm card. Laging nagtatanong ang Playground.",
    confirmHintWrite: "Naka-on bilang default para sa POST, PUT at PATCH, na may binabago sa kabilang panig. I-off lang kung ligtas itong patakbuhin nang hindi nagtatanong. Laging nagtatanong ang Playground.",
    identity: "Kailangan ng verified na identity",
    identityHint: "Tatakbo lang kapag nagpasa ang widget ng signed user token (Widget Studio → Security). Galing sa token ang mga identity field, hindi sa chat.",
    delete: "Burahin",
    cancel: "Kanselahin",
    save: "I-save ang aksyon",
    saved: "Na-save ang aksyon · magagamit na ng assistant",
    created: "Nagawa ang aksyon",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Hindi na matatawag ng assistant ang aksyong ito. Mabubura rin ang kasaysayan ng mga run nito.",
    deleteConfirm: "I-type ang pangalan ng aksyon para kumpirmahin",
    deleted: "Nabura ang aksyon",
    readOnly: "Makikita mo ang aksyong ito pero hindi mo ito mababago.",
    audience: "Sino ang puwedeng gumamit ng aksyong ito",
    audienceHint: "Hindi makikita ng mga bisitang wala sa mga antas na ito ang aksyong ito. Nauuna pa rin ang limit ng agent na “Sino ang puwedeng makipag-chat” ({{levels}}).",
    audienceEveryone: "Laging available sa lahat ang Makipag-usap sa tao, kaya hindi mababago ang audience nito.",
    audienceRequired: "Pumili ng kahit isang audience.",
  },
  test: {
    title: "Subukan",
    live: "Tumatakbo sa live na endpoint",
    input: "Sample input (JSON)",
    run: "Patakbuhin ang test",
    invalidJson: "Hindi wastong JSON ang sample input.",
    saveFirst: "I-save muna ang aksyon para makapag-test.",
    builtin: "Sa loob ng usapan tumatakbo ang mga built-in na aksyon. Subukan sila sa Playground.",
    ok: "{{status}} OK",
    status: "HTTP {{status}}",
    failed: "Hindi naipadala",
    meta: "{{duration}} · {{bytes}} B",
    response: "Response",
    receives: "Ang matatanggap ng assistant",
    errors: "Mga problema",
  },
  runs: {
    title: "Mga kamakailang run ng aksyon",
    subtitle: "Huling 8 run · naka-redact ang mga input ayon sa iyong privacy settings",
    export: "I-export ang CSV",
    exportHint: "Ie-export ang bawat kumpirmado o tapos na run sa nakaraang 7 araw, naka-redact ang input at output.",
    exported: "Na-export ang {{name}}",
    time: "Oras",
    action: "Aksyon",
    conversation: "Usapan",
    status: "Status",
    duration: "Tagal",
    openConversation: "Buksan ang usapan",
    noConversation: "—",
    empty: "Wala pang run",
    emptyBody: "Lalabas dito ang mga run kapag tumawag ang assistant ng aksyon sa isang usapan.",
    statuses: {
      succeeded: "Tagumpay",
      failed: "Pumalya",
      timed_out: "Nag-timeout",
      cancelled: "Kinansela",
      pending_confirmation: "Naghihintay ng kumpirmasyon",
      expired: "Nag-expire",
      running: "Tumatakbo",
    },
  },
  planFeature: "Custom na aksyon",
  availability,
  bookingForm,
};
